import WhiteLoader from './WhiteLoader';

export default WhiteLoader;
